export default {"src":"/_next/static/media/orderShippingTable.53765585.svg","height":485,"width":484,"blurWidth":0,"blurHeight":0};